export default "__VITE_ASSET__BslEYOs9__"